// src/hooks/useGroqKey.js
import { useState } from 'react';

export const useGroqKey = () => {
  const [apiKey, setApiKey] = useState(() => {
    return localStorage.getItem('groqApiKey') || process.env.REACT_APP_GROQ_API_KEY || '';
  });

  const [isKeySet, setIsKeySet] = useState(() => !!apiKey);

  const setKey = (newKey) => {
    if (newKey) {
      localStorage.setItem('groqApiKey', newKey);
      setApiKey(newKey);
      setIsKeySet(true);
    }
  };

  return { apiKey, isKeySet, setKey };
};